import React, { useEffect } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#404040'
const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 24,
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#404040',
    },
    row: {
        flexDirection: 'row',
        borderBottomColor: '#404040',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 10,
        fontStyle: 'bold',
    },
    // total: {
    //     width: '15%',
    //     textAlign: 'right',
    //     paddingRight: 8,
    // },
    details: {
        width: '100%',
        textAlign: 'left',
        paddingLeft: 8,
    },
    product: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
    subscription: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
    from: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
    to: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
    dueDate: {
        width: '20%',
        textAlign: 'center',
        paddingRight: 8,
    },
  });

const InvoiceDetailsTable = ({invoice}) => {
    // const total = items.map(item => item.qty * item.rate)
    //     .reduce((accumulator, currentValue) => accumulator + currentValue , 0)

    // console.log("Lohith:Payment:InvoiceDetailsTable:invoice = ",invoice);
    return(    
        <View style={styles.tableContainer}>
            <View style={styles.row}>
                <Text style={styles.details}>DETAILS</Text>
            </View>
            {/* <View style={styles.row}>
                <Text style={styles.description}>MONTHLY SUBSCRIPTION</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.description}>INVOICE PERIOD</Text>
            </View> */}
            <View style={styles.row}>
                <Text style={styles.product}>PRODUCT</Text>
                <Text style={styles.subscription}>SUBSCRIPTION</Text>
                <Text style={styles.from}>FROM</Text>
                <Text style={styles.to}>TO</Text>
                {/* <Text style={styles.dueDate}>DUE DATE</Text> */}
            </View>
            {invoice.items.map( item => (
                <View style={styles.row}>
                    <Text style={styles.product}>
                        {
                            item.name == 'Hi' 
                            ? 'hi™' 
                            : item.name == 'HiLite' 
                            ? 'hilite™' 
                            : 'hiRender™'
                        }
                    </Text>
                    <Text style={styles.subscription}>
                        {
                            item.month == 12 
                            ?  "Annually"
                            : item.month == 6 
                            ? "Half-Yearly"
                            : item.month == 3 
                            ? "Quarterly"
                            : "Monthly"
                        }
                    </Text>
                    {/* <Text style={styles.from}>{returnDate(new Date())}</Text>
                    <Text style={styles.to}>{returnEndDate(item.month)}</Text>
                    <Text style={styles.dueDate}>{returnDueDate(2)}</Text> */}
                    <Text style={styles.from}>{invoice.from_date}</Text>
                    <Text style={styles.to}>{invoice.to_date}</Text>
                    {/* <Text style={styles.dueDate}>{invoice.due_date}</Text> */}
                </View>
            ))}
            
            {/* <View style={styles.row}>
                <Text style={styles.product}>hi™</Text>
                <Text style={styles.subscription}>Monthly</Text>
                <Text style={styles.from}>{invoice.from_date}</Text>
                <Text style={styles.to}>{invoice.to_date}</Text>
                <Text style={styles.dueDate}>{invoice.due_date}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.product}>hilite™</Text>
                <Text style={styles.subscription}>Quarterly</Text>
                <Text style={styles.from}>{invoice.from_date}</Text>
                <Text style={styles.to}>{invoice.to_date}</Text>
                <Text style={styles.dueDate}>{invoice.due_date}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.product}>hiRender™</Text>
                <Text style={styles.subscription}>Annually</Text>
                <Text style={styles.from}>{invoice.from_date}</Text>
                <Text style={styles.to}>{invoice.to_date}</Text>
                <Text style={styles.dueDate}>{invoice.due_date}</Text>
            </View> */}
        </View>
        
    )
};
  
  export default InvoiceDetailsTable